import { render } from "./specialList.vue?vue&type=template&id=3148b141"
import script from "./specialList.vue?vue&type=script&lang=js"
export * from "./specialList.vue?vue&type=script&lang=js"

import "./specialList.vue?vue&type=style&index=0&id=3148b141&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__